import {BrowserShell} from "./hero/BrowserShell";
import { CapabilityChips } from "./hero/CapabilityChips";
import { HeroMetrics } from "./hero/HeroMetrics";
import { PlatformHeader } from "./hero/PlatformHeader";
import { TransformationChart } from "./hero/TransformationChart";
import { ActivityFeed } from "./hero/ActivityFeed";
import { FloatingInsightBadge } from "./hero/FloatingInsightBadge";
import { FloatingMobileCard } from "./hero/FloatingMobileCard";
import { FloatingWorkflowCard } from "./hero/FloatingWorkflowCard";

export function HeroVisual() {
    return (
      <div className="relative">
        {/* <div
          className="
              absolute
              inset-0
              -z-10
              rounded-[48px]
              bg-gradient-to-br
              from-primary/10
              via-transparent
              to-accent/10
              blur-3xl
          "
        />
        <div className="absolute -left-16 top-24 h-48 w-48 rounded-full bg-primary/15 blur-[90px]" />

        <div className="absolute -right-20 bottom-10 h-52 w-52 rounded-full bg-cyan-400/10 blur-[110px]" /> */}

        <BrowserShell>

          <PlatformHeader accent="#0F8B8D" />

          <CapabilityChips />

          <div className="px-4 pb-7">
            <HeroMetrics accent="#0F8B8D" />
            <div className="grid gap-4 lg:grid-cols-[1fr_1.15fr]">
              <ActivityFeed accent="#0F8B8D"/>
              <TransformationChart accent="#0F8B8D" />
            </div>
          </div>

        </BrowserShell>
        <FloatingWorkflowCard accent="#0F8B8D" />

        <FloatingMobileCard accent="#0F8B8D" />

        <FloatingInsightBadge accent="#0F8B8D" />
      </div>
    );
}

// import { motion } from "framer-motion";
// import {
//   LineChart,
//   Users,
//   Gauge,
//   Smartphone,
//   CheckCircle2,
//   Workflow,
//   Sparkles,
// } from "@/icons";
// import { EASE } from "@/animations/motion";

// const float = (delay = 0) => ({
//   animate: { y: [0, -10, 0] },
//   transition: { duration: 5, ease: "easeInOut", repeat: Infinity, delay },
// });

// /**
//  * Deliberately-crafted product preview — a browser-framed analytics dashboard,
//  * a clipped mobile card, plus floating workflow + notification panels. Pure
//  * CSS/SVG (no stock photography), spotlit and layered for depth.
//  */
// export function HeroVisual() {
//   const bars = [42, 58, 36, 72, 64, 88, 76, 94, 60, 82, 70, 96];

//   return (
//     <div className="relative mx-auto max-w-5xl">
//       <div className="pointer-events-none absolute -inset-x-10 -top-10 bottom-0 -z-10 rounded-[2.5rem] bg-gradient-to-b from-primary/[0.08] to-transparent blur-2xl" />

//       {/* Browser frame */}
//       <div className="overflow-hidden rounded-[1.5rem] border border-border bg-card shadow-[0_40px_120px_-40px_rgba(15,23,42,0.35)]">
//         <div className="flex items-center gap-2 border-b border-border bg-background/60 px-5 py-3.5">
//           <span className="h-3 w-3 rounded-full bg-danger/70" />
//           <span className="h-3 w-3 rounded-full bg-warning/70" />
//           <span className="h-3 w-3 rounded-full bg-success/70" />
//           <div className="ml-4 hidden h-6 flex-1 items-center rounded-md bg-muted px-3 text-[11px] text-muted-foreground sm:flex">
//             vibewell.live/dashboard
//           </div>
//         </div>

//         <div className="grid gap-5 p-5 sm:grid-cols-[1.1fr_1.6fr] sm:p-7">
//           <div className="flex flex-col gap-4">
//             {[
//               { icon: Users, label: "AI Agents", value: "128", tone: "text-primary" },
//               { icon: Gauge, label: "Workflow Automation", value: "98%", tone: "text-accent" },
//               { icon: LineChart, label: "Enterprise Systems", value: "42", tone: "text-primary" },
//             ].map(({ icon: Icon, label, value, tone }, i) => (
//               <motion.div
//                 key={label}
//                 initial={{ opacity: 0, x: -16 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5, ease: EASE, delay: 0.15 + i * 0.1 }}
//                 className="rounded-2xl border border-border bg-background p-4"
//               >
//                 <div className="flex items-center justify-between">
//                   <span className="text-xs text-muted-foreground">{label}</span>
//                   <Icon className={`h-4 w-4 ${tone}`} />
//                 </div>
//                 <p className="mt-2 font-heading text-2xl font-bold text-foreground">
//                   {value}
//                 </p>
//               </motion.div>
//             ))}
//           </div>

//           <div className="rounded-2xl border border-border bg-background p-5">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-xs text-muted-foreground">Business Transformation Index</p>
//                 <p className="font-heading text-lg font-semibold text-foreground">
//                   Live
//                 </p>
//               </div>
//               <span className="rounded-full bg-primary/10 px-2.5 py-1 text-xs font-medium text-primary">
//                 +38%
//               </span>
//             </div>
//             <div className="mt-6 flex h-40 items-end gap-2">
//               {bars.map((h, i) => (
//                 <motion.div
//                   key={i}
//                   initial={{ height: 0 }}
//                   whileInView={{ height: `${h}%` }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.6, ease: EASE, delay: 0.2 + i * 0.04 }}
//                   className="flex-1 rounded-t-md bg-gradient-to-t from-primary/30 to-primary"
//                   style={{ minHeight: 6 }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Floating: workflow panel */}
//       <motion.div
//         {...float(0.4)}
//         className="absolute -left-4 top-16 hidden w-52 rounded-2xl border border-border bg-card/90 p-4 shadow-[0_24px_60px_-24px_rgba(15,23,42,0.4)] backdrop-blur lg:block"
//       >
//         <div className="flex items-center gap-2">
//           <span className="inline-flex h-7 w-7 items-center justify-center rounded-lg bg-accent/10 text-accent">
//             <Workflow className="h-3.5 w-3.5" />
//           </span>
//           <span className="text-xs font-semibold text-foreground">AI Workflow</span>
//         </div>
//         <div className="mt-3 space-y-2">
//           {["Capture", "Analyse", "Automate", "Deliver"].map((step, i) => (
//             <div key={step} className="flex items-center gap-2">
//               <span className="h-2 w-2 rounded-full bg-primary" />
//               <span className="text-[11px] text-muted-foreground">{step}</span>
//               {i < 2 && <span className="ml-auto text-[10px] text-success">✓</span>}
//             </div>
//           ))}
//         </div>
//       </motion.div>

//       {/* Floating: notification pill */}
//       <motion.div
//         {...float(1)}
//         className="absolute -right-2 top-8 hidden items-center gap-2 rounded-full border border-border bg-card/90 px-3.5 py-2 shadow-[0_20px_50px_-20px_rgba(15,23,42,0.4)] backdrop-blur lg:flex"
//       >
//         <CheckCircle2 className="h-4 w-4 text-success" />
//         <span className="text-xs font-medium text-foreground">Recent AI Activities</span>
//       </motion.div>

//       {/* Floating: mobile app card */}
//       <motion.div
//         {...float(0.7)}
//         className="absolute -bottom-8 -right-2 hidden w-44 overflow-hidden rounded-[1.75rem] border border-border bg-card p-3 shadow-[0_30px_80px_-30px_rgba(15,23,42,0.45)] sm:block lg:-right-10"
//       >
//         <div className="rounded-[1.25rem] bg-secondary p-4 text-white">
//           <div className="flex items-center gap-2">
//             <span className="inline-flex h-7 w-7 items-center justify-center rounded-lg bg-accent/20 text-accent">
//               <Smartphone className="h-3.5 w-3.5" />
//             </span>
//             <span className="text-xs font-medium text-slate-300">VibeWell</span>
//           </div>
//           <p className="mt-4 text-[11px] text-slate-400">Mobile Workforce</p>
//           <p className="font-heading text-xl font-bold">1,248</p>
//           <p className="font-heading text-xl font-bold">Engineers Online</p>
//           <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-white/10">
//             <div className="h-full w-3/4 rounded-full bg-accent" />
//           </div>
//         </div>
//       </motion.div>

//       {/* Floating: AI insight chip */}
//       <motion.div
//         {...float(1.4)}
//         className="absolute -bottom-6 left-6 hidden items-center gap-2 rounded-full border border-border bg-card/90 px-3.5 py-2 shadow-[0_20px_50px_-20px_rgba(15,23,42,0.4)] backdrop-blur lg:flex"
//       >
//         <Sparkles className="h-4 w-4 text-accent" />
//         <span className="text-xs font-medium text-foreground">
//           Predictive Insight Generated
//         </span>
//       </motion.div>
//     </div>
//   );
// }
